import React, { Component } from 'react';
import ThemeSlidingSwitch from './ThemeSlidingSwitch/ThemeSlidingSwitch';

class ThemeSwitch extends Component {
    constructor(props) {
        super(props);

        const currentTime = new Date().getHours();
        if(currentTime >= 6 && currentTime <= 20) {
            this.state = {
                theme: 'light'
            }
        } else {
            this.state = {
                theme: 'dark'
            }
        }
    }

    themeSwitchHandler = () => {
        if(document.getElementById("body").classList.contains('dark')) {
            document.getElementById("body").classList.add('light');
            document.getElementById("body").classList.remove('dark');
            this.setState({
                theme: 'light'
            })
        } else {
            document.getElementById("body").classList.add('dark');
            document.getElementById("body").classList.remove('light');
            this.setState({
                theme: 'dark'
            })
        }
    }

    render() {
        return (
            <ThemeSlidingSwitch theme={this.state.theme} onChange={this.themeSwitchHandler} checked={this.state.theme === 'dark' ? true : false} />
        );
    }
}

export default ThemeSwitch;


// WEBPACK FOOTER //
// ./src/components/ThemeSwitch/ThemeSwitch.js